exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.OverlayScreen[data-v-1cd48bc8] {\n  position: absolute;\n  background-color: rgba(0, 0, 0, 0.1);\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  justify-items: center;\n  align-items: center;\n  z-index: 20;\n  user-select: none;\n}\n.OverlayScreen.fade-enter-active[data-v-1cd48bc8], .OverlayScreen.fade-leave-active[data-v-1cd48bc8] {\n    transition: opacity 0.2s;\n}\n.OverlayScreen.fade-enter[data-v-1cd48bc8], .OverlayScreen.fade-leave-to[data-v-1cd48bc8] {\n    opacity: 0;\n}\n.OverlayScreen._transparent[data-v-1cd48bc8] {\n    background-color: transparent;\n}\n", ""]);

// exports
